













































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { companyServer, doublePrevention, regionServe, spaceServe } from '@/api/installServer';
import RiskAndDangerDialog from '@/views/doublePrevention/riskPointHazardSource/unit/riskAndDangerDialog.vue';
import { arrayToTree } from '@/util/arrayToTree';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: { CollapseTransition, PagingUnit, RiskAndDangerDialog },
  mixins: [TableStripe],
})
export default class RiskPointHazardSource extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据

  // 表单数据对象
  formData: any = {
    type: '',
    areaId: '',
  };
  // table 数据对象
  tableData: any = [];

  private userInfo: any = {};

  // 执行部门
  subSpaceByAuthOptions: any = [];

  private uploadUrl: any = publishObjectPath.serverUrl + '/api/yunnan/riskPointDangerSource/importExcel';
  headers: any = {};
  fileList: any = [];
  private importLoading: any = false;

  private downloadTemplate() {
    window.location.href = publishObjectPath.imgPathWater + `/doc/风险点危险源导入模版.xlsx`;
  }
  private handleAvatarCardFrontSuccess(file: any) {
    this.importLoading = true;
    if (file.code === '200') {
      this.$message.success('导入成功！');
      this.importLoading = false;
      this.getPageData();
    } else {
      this.$message.warning(file.msg);
      this.importLoading = false;
    }
    this.fileList = [];
  }
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe
      .getAreaAndSubAreaList({ areaId: this.userInfo.areaId })
      .then((res: any) => {
        if (res.code === '200') {
          this.subSpaceByAuthOptions = arrayToTree(res.data);
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  mounted() {
    this.headers.Authorization = localStorage.getItem('token');
  }

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.userInfo = JSON.parse((localStorage as any).getItem('userInfo'));
    this.formData.areaId = this.userInfo.areaId;
    this.getSpaceAreaData();
    this.getPageData();
  }

  // 创建开始点击事件
  createExam(handleType: any, type: any, data?: any) {
    const obj: any = {
      handleType,
      type,
    };
    if (data) {
      obj.pid = data.id;
    }
    (this.$refs.RiskAndDangerDialogRef as any).showAddDialog(obj);
  }
  updateExam(data: any) {
    const obj: any = {
      handleType: 'edit',
    };
    (this.$refs.RiskAndDangerDialogRef as any).showAddDialog(obj, data);
  }
  // 打开删除事件
  openDeletedialog(id: any) {
    this.$confirm('确认要删除该条数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        doublePrevention.deleteRiskPointDangerSource(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('数据删除成功！');
            this.getPageData();
          } else {
            this.$message.error(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  // 查看
  viewManagement(data: any) {
    const viewDialog: any = 'viewDialog';
    const viewDialogRef: any = this.$refs[viewDialog];
    viewDialogRef.showDialog(data);
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    doublePrevention
      .getRiskPointDangerSource({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        areaId: this.formData.areaId ? this.formData.areaId : null,
        type: this.formData.type ? this.formData.type : null,
      })
      .then((res: any) => {
        if (res.data) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      type: '',
      areaId: this.userInfo.areaId,
    };
    this.getPageData();
  }
}
